import { Injectable, inject } from '@angular/core';
import {HydraService} from '../../core/services/hydra.service';
import {api} from '../../api/api-dictionnary';
import {HydraCollection} from '../../class/generic/hydra-collection';
import {Discipline} from '../../interface/api/Discipline';
import {Observable} from 'rxjs';
import {ExDiscipline} from '../../class/ex/ExDiscipline';
import {map} from 'rxjs/operators';

@Injectable()
export class DisciplineService {
    private hydraService = inject(HydraService);

    constructor() {}

    public getDisciplines(cache: boolean = false): Observable<Discipline[]> {
        return this.hydraService.getList(api.discipline + '?enabled=true', cache).pipe(
            map(res => {
                const data = [];
                const response = new HydraCollection(res).getMember();
                response.map(item => {
                    data.push(new ExDiscipline(item));
                });
                return data;
            })
        );
    }
}
